import React from 'react'

import styled, { useTheme } from 'styled-components/native'

import { Display } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/display/Display'
import { InfoIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/InfoIcon'
import { NumberBadge } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/NumberBadge'
import { Tooltip } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/tooltip/Tooltip'
import { MessengerUtilityItemProps } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/messengerUtilityItem/MessengerUtilityItem'
import { MessengerUtilityItemList } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/messengerUtilityItemList/MessengerUtilityItemList'
import { DisplaySize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'

type MessengerUtilityItemSmartSuggestionsProps = {
  items: MessengerUtilityItemProps[]
  title: React.ReactNode
  tooltip: React.ReactNode
}

const TitleRow = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['4px'],
  padding: theme.spacing['16px'],
}))
const Counter = styled(NumberBadge)({
  alignSelf: 'center',
  borderRadius: '4px',
})

const MessengerUtilityItemSmartSuggestions: React.FC<MessengerUtilityItemSmartSuggestionsProps> = ({
  items,
  title,
  tooltip,
}) => {
  const { colors } = useTheme()

  return (
    <>
      <TitleRow>
        <Display size={DisplaySize.EYEBROW} text={title} />
        <Counter number={items.length} backgroundColor={colors.components.utilityItemBadge.fill} />
        <Tooltip hoverEnabled content={tooltip}>
          <InfoIcon size={18} fillColor={colors.iconDefault} />
        </Tooltip>
      </TitleRow>
      <MessengerUtilityItemList items={items} />
    </>
  )
}

export default MessengerUtilityItemSmartSuggestions
